import request from '@/utils/request'


// 查询银行支行列表
export function listBranch(query) {
  return request({
    url: '/biz/admin/merchant/bank/branch/list',
    method: 'get',
    params: query
  })
}

// 查询银行支行分页
export function pageBranch(query) {
  return request({
    url: '/biz/admin/merchant/bank/branch/page',
    method: 'get',
    params: query
  })
}

export function pageBank(query) {
  return request({
    url: '/biz/admin/merchant/bank/page',
    method: 'get',
    params: query
  })
}


// 查询银行支行详细
export function getBranch(data) {
  return request({
    url: '/biz/admin/merchant/bank/branch/detail',
    method: 'get',
    params: data
  })
}

// 新增银行支行
export function addBranch(data) {
  return request({
    url: '/biz/admin/merchant/bank/branch/add',
    method: 'post',
    data: data
  })
}

// 修改银行支行
export function updateBranch(data) {
  return request({
    url: '/biz/admin/merchant/bank/branch/edit',
    method: 'post',
    data: data
  })
}

// 删除银行支行
export function delBranch(data) {
  return request({
    url: '/biz/admin/merchant/bank/branch/delete',
    method: 'post',
    data: data
  })
}


// 新增银行支行
export function addBank(data) {
  return request({
    url: '/biz/admin/merchant/bank/add',
    method: 'post',
    data: data
  })
}

// 修改银行支行
export function updateBank(data) {
  return request({
    url: '/biz/admin/merchant/bank/edit',
    method: 'post',
    data: data
  })
}

export function commonBank(data) {
  return request({
    url: '/biz/admin/merchant/bank/common',
    method: 'post',
    data: data
  })
}


// 查询银行支行详细
export function getBank(data) {
  return request({
    url: '/biz/admin/merchant/bank/detail',
    method: 'get',
    params: data
  })
}
